import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { PlatformConfigState } from '@core/models/platform-config.state';

/**
 * Platform commerce policy contract (HLD ADM-02). Read-only from the
 * storefront - the Admin Portal owns the write side.
 */
export interface PlatformConfigRepository {
  get(): Observable<PlatformConfigState>;
}

export const PLATFORM_CONFIG_REPOSITORY = new InjectionToken<PlatformConfigRepository>('PLATFORM_CONFIG_REPOSITORY');
